import React from 'react';
import { Outlet } from 'react-router-dom';
import ParentLayout from './ParentLayout';
import { ParentDataProvider } from '../context/ParentDataContext';

export default function ParentShell() {
  return (
    <ParentDataProvider>
      <ParentLayout>
        <Outlet />
      </ParentLayout>
    </ParentDataProvider>
  );
}
